import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  getCurrentInstance,
  useAttrs,
} from 'vue'
import CUSkeletonLoaderCheckbox from '@/components/CUSkeletonLoaderCheckbox.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CUCheckBox',
  props: {
    skeletonLoader: { type: Boolean },
    labelWidth: null,
    value: { type: Boolean }
  },
  emits: ["input", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void
  (e: 'change', value: boolean): void
}), expose: any, slots: any, attrs: any }) {





const attrs = useAttrs()
const instance = getCurrentInstance()

// class/style are not in attrs — forward onto v-checkbox so utilities like
// margin-t-0 override Vuetify's .v-input--selection-controls { margin-top: 16px }
const checkboxClass = computed(() => {
  const data = instance?.proxy?.$vnode?.data
  if (!data) return undefined
  return [data.staticClass, data.class]
})

const listeners = computed(() => {
  return {
    ...attrs,
    // v-checkbox model event is `change` (inputValue); also emit `input` for v-model
    change: (event: boolean) => {
      emit('change', event)
      emit('input', event)
    },
    input: (event: boolean) => {
      emit('input', event)
    },
  }
})

const hideDetails = computed(
  () => !!(attrs['hide-details'] ?? attrs.hideDetails)
)

return { __sfc: true,emit, attrs, instance, checkboxClass, listeners, hideDetails, CUSkeletonLoaderCheckbox }
}

})